import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import CalculatorSection from './components/CalculatorSection';
import SpecialtiesSection from './components/SpecialtiesSection';
import BenefitsSection from './components/BenefitsSection';
import TransformSection from './components/TransformSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import FinalCTASection from './components/FinalCTASection';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ContactUs from './pages/ContactUs';
import RCMServices from './pages/RCMServices';
import Specialties from './pages/Specialties';
import Pricing from './pages/Pricing';
import AboutUs from './pages/AboutUs';

function HomePage() {
  return (
    <>
      <HeroSection />
      <StatsSection />
      <AboutSection />
      <ServicesSection />
      <CalculatorSection />
      <SpecialtiesSection />
      <BenefitsSection />
      <TransformSection />
      <CTASection />
      <FAQSection />
      <FinalCTASection />
    </>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-white">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/rcm-services" element={<RCMServices />} />
          <Route path="/specialties" element={<Specialties />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/about-us" element={<AboutUs />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
